export interface ISectionFieldConfigurationServer {
  isPII?: boolean;
  isQrCodeAllowed?: boolean;
  isDuplicateAllowed?: boolean;
  enableSectionShowOrHide?: boolean;
  isSectionShowOrHide?: string;

}

export interface ISectionFieldConfigurationClient {
  isPII?: boolean;
  isQrCodeAllowed?: boolean;
  isDuplicateAllowed?: boolean;
  enableSectionShowOrHide?: boolean;
  isSectionShowOrHide?: string;
}

export const transformSectionConfigClientToServer = (
  fieldConfigClient: ISectionFieldConfigurationClient
): ISectionFieldConfigurationServer => {
  const fieldConfigServer = {
    isPII: fieldConfigClient?.isPII || false,
    isQrCodeAllowed: fieldConfigClient?.isQrCodeAllowed,
    enableSectionShowOrHide: fieldConfigClient?.enableSectionShowOrHide || false,
    isSectionShowOrHide: fieldConfigClient?.isSectionShowOrHide,
  };
  return fieldConfigServer;
};

export const transformSectionConfigServerToClient = (
  fieldConfigServer: ISectionFieldConfigurationServer
): ISectionFieldConfigurationClient => {
 
  const fieldConfigClient = {
    isPII: fieldConfigServer?.isPII || false,
    isQrCodeAllowed: fieldConfigServer?.isQrCodeAllowed,
    enableSectionShowOrHide: fieldConfigServer?.enableSectionShowOrHide || false,
    isSectionShowOrHide: fieldConfigServer?.isSectionShowOrHide,
  };
  return fieldConfigClient;
};
